<script>
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';

    export default {
        mixins: [ Treeselect ],

        registryName: 'tree-select'
    }
</script>



// WEBPACK FOOTER //
// src/components/TreeSelect.vue